import { useQuery } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { GQL_SSO_PROVIDERS } from '~/gql/sso/sso'

/**
 * Boutons SSO de l'écran de connexion (#40).
 *
 * La liste vient de la configuration de l'organisation : tant qu'aucun
 * fournisseur n'est activé, rien ne s'affiche — plus de bouton SSO en dur qui
 * menait à une erreur sur une instance sans IdP.
 */
function LoginSSO() {
  const { t } = useTranslation()
  const { data } = useQuery(GQL_SSO_PROVIDERS)

  const providers = data?.ssoProviders ?? []
  if (providers.length === 0) return null

  return (
    <div className="flex flex-col gap-3">
      {providers.map(provider => (
        <Button
          key={provider.id}
          variant="outline"
          type="button"
          onClick={() => (location.href = provider.loginUrl)}
          className="h-12 w-full rounded-full"
        >
          {t('login.sso.with', { provider: provider.label })}
        </Button>
      ))}
    </div>
  )
}

export default LoginSSO
